import { render, staticRenderFns } from "./coreCourses.vue?vue&type=template&id=394edc06&scoped=true&"
import script from "./coreCourses.vue?vue&type=script&lang=js&"
export * from "./coreCourses.vue?vue&type=script&lang=js&"
import style0 from "./coreCourses.vue?vue&type=style&index=0&id=394edc06&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "394edc06",
  null
  
)

export default component.exports